module.exports = __webpack_public_path__ + "media/images/icon__email-50810d4f476f031db4add5e2ca246306.png";